import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import LoadingDots from "@/components/LoadingDots";
import useFinalization from "@/hooks/useFinalization";
import useFinalizationInstructions from "@/hooks/useFinalizationInstructions";

export const Route = createFileRoute("/$locale/$partner/_app/_card/_paired/process-completed")({
	component: ProcessCompleted,
});

function ProcessCompleted() {
	const { t } = useTranslation();
	const { finalizeTransaction, isLoading } = useFinalization();

	const finalizationInstructions = useFinalizationInstructions();

	useEffect(() => {
		finalizeTransaction();
	}, []);

	if (isLoading)
		return (
			<div className="flex h-[100dvh] items-center justify-center">
				<LoadingDots />
			</div>
		);

	return (
		<div className="flex flex-col h-screen-minus-64 items-center justify-center">
			<div className="w-40 h-40 relative shrink-0">
				<img
					src={`/images/success-icon.svg`}
					alt={"success icon"}
					className="w-full h-full object-contain"
				/>
			</div>
			<h2 className="pt-5">{t("Success screen.Process Completed")}</h2>

			{finalizationInstructions && (
				<div
					className="mt-12 px-6 overflow-y-auto w-full flex flex-col max-w-prose max-h-[45vh] [&_ol]:list-decimal [&_ul]:list-disc [&_li]:ml-6 sm:[&_li]:ml-8  [&_strong]:!text-[length:inherit] [&_strong]:font-semibold"
					dangerouslySetInnerHTML={{
						__html: finalizationInstructions,
					}}
					style={{
						color: "inherit",
						wordWrap: "break-word",
					}}
				/>
			)}
		</div>
	);
}
